import EventEmitter from './EventEmitter.js'

export default class Sizes extends EventEmitter
{
    constructor()
    {
        super()

        // Setup
        // this.width = window.innerWidth
        // this.height = window.innerHeight
        this.isVertical=false
        this.isSmartphone=false
        this.vertConst=0
        this.verifyVertical()
        this.pixelRatio = Math.min(window.devicePixelRatio, 1)

        // Resize event
        window.addEventListener('resize', () =>
        {
            this.verifyVertical()
            // this.width = window.innerWidth
            // this.height = window.innerHeight
            this.pixelRatio = Math.min(window.devicePixelRatio, 1)
            this.trigger('resize')
        })

    }
    verifyVertical(){
        this.width = window.innerWidth
        this.realHeight= window.innerHeight
        if (this.width/window.innerHeight < 1)
        {
            this.isVertical=true
            this.height = this.width
            if (this.width<450) this.isSmartphone=true
            this.vertConst=(window.innerHeight-this.height)/2+this.height

        }
        else
        {this.isVertical=false
          this.height = window.innerHeight
          this.vertConst=this.height/2
        }  
    }

}